// extracted by mini-css-extract-plugin
export default {"ModelsCatalog":"ReviewsCatalog_ModelsCatalog__fOJxW","scroll":"ReviewsCatalog_scroll__niJbR"};